import React, { useMemo, useState } from "react";
import {
    Card,
    Typography,
    Stack,
    CircularProgress,
    Box,
    Button,
    Avatar,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import { useNavigate } from "react-router-dom";
import EventPopup from "./EventPopup";
import dayjs from "dayjs";

const PastEventsCard = ({ report, loading = false }) => {
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);


    const pastEvents = useMemo(() => {
        if (!report?.callendarEvents) return [];

        const now = new Date();

        console.log('report.callendarEvents', report.callendarEvents)

        return report.callendarEvents
            .filter((event) => event?.end && new Date(event.end) < now)
            .sort((a, b) => new Date(b.end) - new Date(a.end));
    }, [report]);

    return (
        <Card sx={{ mb: 3, p: 3, borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h6" mb={2} fontWeight={600}>
                {/* Wydarzenia, w których brało udział twoje dziecko */}
                Wydarzenia, które były zaplanowane dla twojego dziecka
            </Typography>

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                    <CircularProgress />
                </Box>
            )}

            {!loading && pastEvents.length === 0 && (
                <Typography color="text.secondary">
                    Brak dostępnych wydarzeń
                </Typography>
            )}

            {!loading && pastEvents.length > 0 && (
                <Stack spacing={2}>
                    {pastEvents.map((event) => {
                        const eventDate = new Date(event.start);

                        return (
                            <>
                                <Card
                                    key={event.id}
                                    sx={{
                                        p: 2,
                                        borderRadius: 2,
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: 2,
                                        background: "#f9fafb",
                                        boxShadow: 1,
                                        transition: "0.2s",
                                        "&:hover": {
                                            boxShadow: 4,
                                        },
                                    }}
                                >
                                    <Avatar
                                        sx={{ bgcolor: "#294e6b", width: 40, height: 40, mt: 0.5 }}
                                    >
                                        <EventIcon />
                                    </Avatar>

                                    <Box sx={{ flex: 1 }}>
                                        <Typography fontWeight={600}>
                                            {event.title || "Bez nazwy wydarzenia"}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                mt: 0.5,
                                            }}
                                        >
                                            <EventIcon sx={{ fontSize: 16, color: "#294e6b" }} />
                                            {/* {eventDate.toLocaleString("pl-PL")} */}
                                            {dayjs(eventDate).format('DD.MM.YYYY HH:mm')}
                                        </Typography>

                                        {event.meta?.description && (
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                {event.meta?.description}
                                            </Typography>
                                        )}

                                        <Box sx={{ mt: 1 }}>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() =>
                                                    // navigate(`/vr/callendar/${event.id}`)
                                                    setOpen(true)
                                                }
                                            >
                                                Szczegóły
                                            </Button>
                                        </Box>
                                    </Box>
                                </Card>

                                <EventPopup
                                    open={open}
                                    onClose={() => setOpen(false)}
                                    event={event}
                                />
                            </>
                        );
                    })}
                </Stack>
            )}
        </Card>
    );
};

export default PastEventsCard;